export default "__VITE_ASSET__f273af48__"